'use strict';

var Sugar = require('sugar-core'),
    ARRAY_OPTIONS = require('./var/ARRAY_OPTIONS');

var _arrayOptions = ARRAY_OPTIONS._arrayOptions;

module.exports = Sugar.Array.getOption;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/getOption.js
// module id = 763
// module chunks = 1